import React from 'react';
import { useTenant } from '../contexts/TenantContext';

/**
 * V2Switcher — Renvoie V1 ou V2 selon le tenant.
 *
 *  - tenant `tcn` → renvoie `<V1 />` (rien ne change côté TCN)
 *  - autres tenants (incl. `generic`) → renvoie `<V2 />`
 *
 * Permet de partager une route (/admin/dashboard, /manager/dashboard) entre TCN
 * (qui reste sur V1 par doctrine "TCN intouché") et les autres tenants (qui
 * basculent sur la V2 portée depuis Black OS — Sprint 2).
 *
 * Pendant le chargement du tenant, rend un placeholder neutre — surtout PAS
 * `<V1 />` : monter un composant V1 (legacy Black OS) sous un tenant Generic
 * déclenche ses effets de fetch sur des tables/colonnes inexistantes côté
 * NoiRock (`users`, `creators.agency_status`…) → spam 404/400 en console à
 * chaque navigation. On attend la résolution du tenant avant de décider.
 */
export default function V2Switcher({ V1, V2 }) {
  const { tenantSlug, loading } = useTenant();
  if (loading) return <div className="min-h-screen bg-background" aria-busy="true" />;
  if (tenantSlug === 'tcn') return <V1 />;
  return <V2 />;
}
